/* D27: single boolean on/off → Switch (not checkbox). */

import { Switch } from 'pi-kiosk-shared/ui';

const LABEL_ID = 'customer-pickup-self-collect-label';
const HELPER_ID = 'customer-pickup-self-collect-helper';

export type SelfCollectConfirmToggleProps = {
  readonly label: string;
  readonly helper: string;
  readonly checked: boolean;
  readonly onCheckedChange: (checked: boolean) => void;
  /** Wrapper chrome — retail uses rounded-xl; legacy uses rounded-md. */
  readonly className?: string;
};

/**
 * Presence gate for self-collect — iOS-style toggle for layout/UX consistency.
 * Keeps stable `data-testid` for e2e / appendix wiring.
 */
export function SelfCollectConfirmToggle({
  label,
  helper,
  checked,
  onCheckedChange,
  className = 'flex items-start justify-between gap-3 rounded-md border border-[var(--color-border)] px-3 py-3',
}: SelfCollectConfirmToggleProps): JSX.Element {
  return (
    <div className={className}>
      <div className="min-w-0 flex-1">
        <p
          id={LABEL_ID}
          className="text-sm font-medium text-[var(--color-on-surface)]"
        >
          {label}
        </p>
        <p
          id={HELPER_ID}
          className="mt-1 text-xs text-[var(--color-on-surface-muted)]"
        >
          {helper}
        </p>
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        aria-labelledby={LABEL_ID}
        aria-describedby={HELPER_ID}
        data-testid="customer-pickup-self-collect-checkbox"
        className="mt-0.5 shrink-0"
      />
    </div>
  );
}
